import React from 'react';
import clsx from 'clsx';

import { Text as StyledText } from './wrappers';

type Size = 'xsmall' | 'small' | 'standard' | 'large' | 'xlarge';

interface IText {
  align?: 'left' | 'center' | 'right';
  as?: React.ElementType;
  className?: string;
  children: React.ReactNode;
  size?: Size | Size[];
  weight?: 'thin' | 'regular' | 'medium' | 'bold';
  tone?: 'main' | 'alt' | 'ghost' | 'error' | 'highlight' | 'success' | 'link' | 'sale';
  whiteSpace?: 'nowrap' | 'normal';
  overflow?: 'ellipsis';
}

const mq = ['ltmd', 'md'];

const Text = ({
  as,
  children,
  className,
  overflow,
  size,
  weight,
  align,
  tone,
  whiteSpace,
}: IText) => {
  const sizeClasses = [];

  if (size && !Array.isArray(size)) {
    sizeClasses.push(`size-${size}`);
  } else if (size && Array.isArray(size)) {
    size.map((s, i) => {
      if (i === 0) {
        sizeClasses.push(`size-${s}`);
      } else {
        sizeClasses.push(`size-${s}-${mq[i]}`);
      }
    });
  }

  return (
    <StyledText
      as={as}
      className={clsx(
        sizeClasses.join(' '),
        className,
        align && `align-${align}`,
        overflow && `overflow-${overflow}`,
        tone && `tone-${tone}`,
        weight && `weight-${weight}`,
        whiteSpace && `white-space-${whiteSpace}`,
      )}>
      {children}
    </StyledText>
  );
};

export default Text;
